









import { Component, Vue, Prop } from "vue-property-decorator"

@Component
export default class ErrorSessionTimeOut extends Vue {
  @Prop({ type: String, default: "" }) readonly content!: string
  @Prop({ type: String, default: "" }) readonly activeRoleKey!: string

  redirectToLogin() {
    const activeRoleKey = this.activeRoleKey
    let routeName = "login"
    switch (activeRoleKey) {
      case "rAdmin":
        routeName = "administrator-login"
        break
      case "rBusiness":
        if (process.env.VUE_APP_WP_VERSION == "v2") {
          routeName = "v2-business-login"
        } else {
          routeName = "business-login"
        }
        break
      case "rCandidate":
        if (process.env.VUE_APP_WP_VERSION == "v2") {
          routeName = "v2-candidate-login"
        } else {
          routeName = "candidate-login"
        }
        break
      default:
        break
    }
    this.$router.push({
      name: routeName,
    })
  }
}
